export const ruleTemplates = [`.ta-Swiper.%class%::-webkit-scrollbar { display: none }`];
